import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalClose,
  ModalFooter,
  Icon,
} from '@repo/ui/components'
import { Button } from '@repo/ui/components'
import { useTranslate, MessagesKeys } from '@repo/shared/hooks'
import { SORT_OPTIONS } from '@repo/shared/store'
import { useState } from 'react'

interface SortModalProps {
  open: boolean
  value: string
  onChange: (value: string) => void
  onClose: () => void
}

export const SortDrawer = ({
  open,
  value,
  onChange,
  onClose,
}: SortModalProps) => {
  const { t } = useTranslate()

  const [localValue, setLocalValue] = useState<string>(value)
  const handleApply = () => {
    onChange(localValue)
    onClose()
  }
  return (
    <Modal open={open} onOpenChange={onClose}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle className='text-center'>
            {t('filters_sort' as MessagesKeys)}
          </ModalTitle>
          <ModalClose />
        </ModalHeader>
        <div className='flex max-h-[200px] overflow-y-auto flex-col gap-md py-md'>
          {SORT_OPTIONS.map((opt) => (
            <Button
              key={opt.value}
              variant={localValue === opt.value ? 'ghost' : 'transparent'}
              className='justify-start [&_svg]:fill-unset active:[&_svg]:fill-unset'
              width='full'
              onClick={() => setLocalValue(opt.value)}
            >
              <span className='flex items-center gap-xs'>
                {localValue === opt.value ? (
                  <Icon
                    name='SelectionIndicator'
                    color='fill-unset'
                    size='sm'
                  />
                ) : (
                  <span className='w-5 h-5' />
                )}
                {t(opt.labelKey as MessagesKeys)}
              </span>
            </Button>
          ))}
        </div>
        <ModalFooter>
          <Button onClick={handleApply} className='w-full' variant='fill'>
            {t('filters_sort_apply')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
